import PaletteExtractor from "./artPalette/palette_extractor";
class GlobalColor {
  constructor() {
    this.color = 0x4444aa;
    this.planeColor = 0x3333aa;
    //
    this.tmp_color = 0x4444aa;
    this.tmp_planeColor = 0x3333aa;
    // color extractor
    this.canvas = document.createElement("canvas");
    this.canvas.width = 512;
    this.canvas.height = 512;
    this.ctx = this.canvas.getContext("2d", { willReadFrequently: true });
    // document.body.appendChild(this.canvas);
  }

  setNewColors() {
    this.color = this.tmp_color;
    this.planeColor = this.tmp_planeColor;
  }

  get planeColorRGB() {
    // convert to rgb
    const r = (this.planeColor >> 16) & 0xff;
    const g = (this.planeColor >> 8) & 0xff;
    const b = this.planeColor & 0xff;
    return [r / 255, g / 255, b / 255];
  }

  convertColor(color) {
    const hexNumber = parseInt(color.slice(1), 16);
    const result = 0x000000 | hexNumber;
    return result;
  }

  getBrightness(color) {
    const r = parseInt(color.substr(1, 2), 16);
    const g = parseInt(color.substr(3, 2), 16);
    const b = parseInt(color.substr(5, 2), 16);
    return r * 0.2126 + g * 0.7152 + b * 0.0722;
  }

  getColorFromImage(image) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        // document.body.appendChild(img);
        this.ctx.drawImage(img, 0, 0);
        const data = this.ctx.getImageData(
          0,
          0,
          this.canvas.width,
          this.canvas.height
        ).data;
        const hexPalette = PaletteExtractor.processImageData(data, 5);
        const orderedPalette = hexPalette.sort(
          (a, b) => this.getBrightness(b) - this.getBrightness(a)
        );
        this.tmp_color = this.convertColor(orderedPalette[1]);
        this.tmp_planeColor = this.convertColor(
          orderedPalette[orderedPalette.length - 2]
        );
        this.arrowColor = this.convertColor(
          orderedPalette[orderedPalette.length - 1]
        );
        resolve(hexPalette);
      };
      img.src = image;
    });
  }
}

export default new GlobalColor();
